import type { ReactNode } from 'react';
import { RASCUNHO } from '@shared/lib/modo';

interface Props {
  /** O que precisa ser escrito ou decidido aqui. */
  children: ReactNode;
  /** De quem ou do que depende a decisão. */
  depende?: string;
  /**
   * Enchimento do tamanho que o texto real vai ter.
   *
   * Não é conteúdo e não deve parecer conteúdo. Existe só para o bloco ganhar
   * a massa certa, senão não dá para julgar uma direção visual olhando uma
   * página cheia de buraco.
   */
  maquete?: string;
}

/**
 * Marginalia de obra.
 *
 * Existe para que os furos apareçam na tela em vez de sumirem dentro de um
 * texto plausível. Nada de placeholder disfarçado de copy.
 *
 * Fora do modo rascunho, não renderiza nada: o visitante não precisa ver a
 * obra por dentro.
 */
export function Pendente({ children, depende, maquete }: Props) {
  if (!RASCUNHO) return null;

  return (
    <div className="my-6 border-l-2 border-sinal bg-sinal-fundo/60 py-3 pl-5">
      <p className="rotulo text-sinal">A escrever</p>
      <p className="mt-1.5 max-w-xl text-apoio leading-relaxed text-tinta-suave">{children}</p>
      {maquete ? (
        <p className="prosa mt-4 max-w-xl border-t border-sinal/25 pt-4 text-tinta-fraca">
          {maquete}
        </p>
      ) : null}
      {depende ? <p className="mt-3 text-miudo text-tinta-fraca">Depende de: {depende}</p> : null}
    </div>
  );
}

/**
 * Valor ainda em aberto dentro de uma ficha ou frase.
 *
 * Em rascunho, aparece marcado. Publicado, quem chama decide se esconde a
 * linha inteira, porque uma ficha cheia de "a confirmar" comunica curso
 * improvisado.
 */
export function ValorPendente({ children }: { children: ReactNode }) {
  if (!RASCUNHO) return null;

  return (
    <span className="border-b border-dashed border-sinal text-sinal">{children}</span>
  );
}
